import FiberManualRecordOutlinedIcon from '@mui/icons-material/FiberManualRecordOutlined';
import { Box, Stack } from '@mui/material';

interface SignalSectionProps {
  children?: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
}

export default function SignalSection({
  children,
  className,
  icon,
}: SignalSectionProps) {
  return (
    <Box className={`signal-section ${className ?? ''}`}>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{ gap: 0.5 }}
      >
        {icon ? icon : <FiberManualRecordOutlinedIcon fontSize="small" />}
        {children}
      </Stack>
    </Box>
  );
}
